import { render } from "./FolderIcon.vue?vue&type=template&id=d476d3d6"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/FolderIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d476d3d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d476d3d6', __exports__)) {
    api.reload('d476d3d6', __exports__)
  }
  
  module.hot.accept("./FolderIcon.vue?vue&type=template&id=d476d3d6", () => {
    api.rerender('d476d3d6', render)
  })

}


export default __exports__